import { RECEIPT_STEPS } from "../receipt-steps.service";
import { BaseState } from "./base-state";
import { ExpenseSelectionState } from "./expense-selection-state";
import { StepStateInterface } from "./step-state.interface";

export class AccommodationDataState extends BaseState implements StepStateInterface {
  ClassConstructor = AccommodationDataState;
  property = 'accommodationData';
  slug = RECEIPT_STEPS.accommodationData;
  lastStep = true;
  async previous(context: any): Promise<StepStateInterface> {
    return new ExpenseSelectionState();
  }
}
